import scoreTimelines from "./score-timelines.json" with { type: "json" };
import { nbaVisualFixtures } from "./nba-visual-fixtures.ts";
import { finalsSources } from "./source-fixtures.ts";
const clock = (period, periodLabel, displayClock) => ({
    period,
    periodLabel,
    displayClock
});
export const finalsScenario = {
    id: "0042500404",
    label: "Spurs at Knicks",
    shortLabel: "SAS · NYK",
    competition: "NBA Finals · Game 4",
    venue: "Madison Square Garden · New York",
    scheduledAt: "2026-06-11T00:30:00Z",
    replayDurationMs: 180_000,
    periodLengthSeconds: 720,
    awayTeam: {
        id: "spurs",
        city: "San Antonio",
        name: "Spurs",
        abbreviation: "SAS",
        color: "#C4CED4",
        contrastColor: "#111111"
    },
    homeTeam: {
        id: "knicks",
        city: "New York",
        name: "Knicks",
        abbreviation: "NYK",
        color: "#006BB6",
        contrastColor: "#F58426"
    },
    replayAnchors: [
        { replayAtMs: 0, period: 1, clockSeconds: 720 },
        { replayAtMs: 4_000, period: 1, clockSeconds: 720 },
        { replayAtMs: 34_000, period: 1, clockSeconds: 0 },
        { replayAtMs: 68_000, period: 2, clockSeconds: 0 },
        { replayAtMs: 82_000, period: 3, clockSeconds: 580 },
        { replayAtMs: 112_000, period: 3, clockSeconds: 0 },
        { replayAtMs: 128_000, period: 4, clockSeconds: 448 },
        { replayAtMs: 155_000, period: 4, clockSeconds: 187 },
        { replayAtMs: 179_000, period: 4, clockSeconds: 2.1 },
        { replayAtMs: 180_000, period: 4, clockSeconds: 0 }
    ],
    scoreEvents: scoreTimelines.games["0042500404"].events,
    storyBeats: [
        { replayAtMs: 0, text: "The Garden is filling for a pivotal Game 4." },
        { replayAtMs: 4_000, text: "Game 4 begins with the Finals balanced on a knife-edge." },
        { replayAtMs: 21_458, text: "Wembanyama is already changing shots at the rim." },
        { replayAtMs: 34_000, text: "San Antonio has stunned the Garden with a 41-point quarter." },
        { replayAtMs: 41_745, text: "A fourth second-quarter three has the Spurs up 24." },
        { replayAtMs: 57_281, text: "Harper gives San Antonio four scorers in double figures." },
        { replayAtMs: 68_000, text: "The Spurs take a 27-point lead into halftime." },
        { replayAtMs: 82_000, text: "The gap returns to the game-high 29. New York needs something historic." },
        { replayAtMs: 94_880, text: "New York has finally found a run—and the Garden has found its voice." },
        { replayAtMs: 112_000, text: "The Knicks have given themselves a fourth-quarter chance." },
        { replayAtMs: 133_483, text: "Anunoby and Towns have dragged the deficit into single digits." },
        { replayAtMs: 146_000, text: "Anunoby's three makes it a four-point game." },
        { replayAtMs: 155_000, text: "One last surge has made this a four-point game." },
        { replayAtMs: 160_971, text: "Brunson's pull-up three cuts it to one." },
        { replayAtMs: 163_697, text: "Hart steals a Spurs possession with New York one point down." },
        { replayAtMs: 168_629, text: "Brunson puts New York in front for the first time." },
        { replayAtMs: 175_340, text: "Castle's free throws give San Antonio the lead again." },
        { replayAtMs: 177_832, text: "Anunoby blocks Fox and gives New York one final chance." },
        { replayAtMs: 179_000, text: "Anunoby tips it in. Madison Square Garden erupts." },
        { replayAtMs: 180_000, text: "The largest comeback in NBA Finals history is complete." }
    ],
    evidenceEvents: [
        {
            id: "finals-pregame",
            replayAtMs: 0,
            clock: clock(1, "Pregame", "12:00"),
            kind: "media",
            facts: ["The Knicks hosted the Spurs at Madison Square Garden for Game 4."],
            sourceRefs: ["NBA game 0042500404", "Getty Images"]
        },
        {
            id: "finals-pregame-story",
            replayAtMs: 0,
            clock: clock(1, "Pregame", "12:00"),
            kind: "media",
            facts: ["The published Spurs-Knicks Story framed San Antonio's chance to level the series before Game 4."],
            sourceRefs: ["Storyteller Story 3b4a3764-9a54-ebcb-c4b0-3a21bf208372"]
        },
        {
            id: "finals-tip",
            replayAtMs: 4_000,
            clock: clock(1, "1st", "12:00"),
            kind: "media",
            facts: ["The Spurs and Knicks tipped off Game 4 at Madison Square Garden."],
            sourceRefs: ["NBA game 0042500404", "Getty Images"]
        },
        {
            id: "spurs-first-quarter",
            replayAtMs: 34_000,
            clock: clock(1, "End 1st", "0:00"),
            kind: "score",
            facts: ["San Antonio led 41–22 after the first quarter."],
            sourceRefs: ["NBA box score", "NBA play-by-play", "X 2064881279967928531"]
        },
        {
            id: "finals-second-quarter-open",
            replayAtMs: 34_944,
            clock: clock(2, "2nd", "11:40"),
            kind: "score",
            facts: ["San Antonio opened the second quarter with a 41–22 lead."],
            sourceRefs: ["NBA play-by-play 18a34c885b0b"]
        },
        {
            id: "wembanyama-block",
            replayAtMs: 21_458,
            clock: clock(1, "1st", "5:01"),
            kind: "media",
            facts: ["Victor Wembanyama blocked Jalen Brunson's pull-up jumper."],
            sourceRefs: ["NBA play-by-play", "Getty Images"]
        },
        {
            id: "harper-double-figures",
            replayAtMs: 57_281,
            clock: clock(2, "2nd", "3:47"),
            kind: "milestone",
            facts: ["Dylan Harper's three gave him 10 points, made the score 69–42 and put four Spurs in double figures."],
            sourceRefs: ["NBA play-by-play"]
        },
        {
            id: "spurs-halftime",
            replayAtMs: 68_000,
            clock: clock(2, "Halftime", "0:00"),
            kind: "stat",
            facts: ["San Antonio led 76–49 and had made 11 of its first 16 threes."],
            sourceRefs: ["NBA box score", "NBA game recap", "Getty 2280981198"]
        },
        {
            id: "finals-end-second",
            replayAtMs: 68_000,
            clock: clock(2, "End 2nd", "0:00"),
            kind: "score",
            facts: ["San Antonio won the second quarter 35–27 and led 76–49 at the horn."],
            sourceRefs: ["NBA box score 2f237b43f2c7", "NBA play-by-play 18a34c885b0b"]
        },
        {
            id: "finals-halftime-story",
            replayAtMs: 68_000,
            clock: clock(2, "Halftime", "0:00"),
            kind: "media",
            facts: ["The published halftime Story captured San Antonio's historic first-half shooting and 27-point lead."],
            sourceRefs: ["Storyteller Story 4711a96a-e7d0-2150-3f8f-3a21c687bf34"]
        },
        {
            id: "largest-deficit",
            replayAtMs: 82_000,
            clock: clock(3, "3rd", "9:40"),
            kind: "milestone",
            facts: [
                "The Spurs led 81–52, matching the 29-point game high they first reached at 3:06 of the second quarter."
            ],
            sourceRefs: ["NBA play-by-play"]
        },
        {
            id: "knicks-still-alive",
            replayAtMs: 112_000,
            clock: clock(3, "End 3rd", "0:00"),
            kind: "run",
            facts: ["New York cut the deficit to 90–75 before the fourth quarter."],
            sourceRefs: ["NBA box score", "NBA play-by-play"]
        },
        {
            id: "finals-fourth-quarter-open",
            replayAtMs: 113_176,
            clock: clock(4, "4th", "11:40"),
            kind: "score",
            facts: ["New York opened the fourth quarter trailing 90–75 after cutting 14 points from the largest deficit."],
            sourceRefs: ["NBA play-by-play 18a34c885b0b"]
        },
        {
            id: "finals-comeback-five",
            replayAtMs: 112_000,
            clock: clock(3, "End 3rd", "0:00"),
            kind: "stat",
            facts: [
                "Towns, Anunoby, Hart, Brunson and Alvarado scored 22 points in seven minutes together, shooting 8-for-11 and finishing plus-15."
            ],
            sourceRefs: ["NBA lineup box 769c74d81f3e"]
        },
        {
            id: "robinson-screen-assists",
            replayAtMs: 112_000,
            clock: clock(3, "End 3rd", "0:00"),
            kind: "stat",
            facts: [
                "Mitchell Robinson recorded three screen assists that created eight points by the end of the third quarter."
            ],
            sourceRefs: ["NBA hustle 9e32d3c639c1", "NBA hustle 9293d748e511"]
        },
        {
            id: "third-quarter-surge",
            replayAtMs: 94_880,
            clock: clock(3, "3rd", "5:31"),
            kind: "run",
            facts: ["New York cut the 29-point deficit to 16 at 81–65."],
            sourceRefs: ["NBA play-by-play"]
        },
        {
            id: "single-digits",
            replayAtMs: 133_483,
            clock: clock(4, "4th", "6:35"),
            kind: "run",
            facts: [
                "OG Anunoby hit a three, stole Dylan Harper's pass and assisted Karl-Anthony Towns' layup to cut San Antonio's lead to 97–88."
            ],
            sourceRefs: ["NBA play-by-play", "X 2064909169254391982"]
        },
        {
            id: "hart-defensive-hinge",
            replayAtMs: 163_697,
            clock: clock(4, "4th", "2:00"),
            kind: "run",
            facts: [
                "Josh Hart stole De'Aaron Fox's pass with New York down 104–103, denying San Antonio a chance to extend the lead."
            ],
            sourceRefs: ["NBA play-by-play 18a34c885b0b actions 677–678"]
        },
        {
            id: "anunoby-four",
            replayAtMs: 146_000,
            clock: clock(4, "4th", "4:34"),
            kind: "score",
            facts: ["OG Anunoby's three cut the Spurs' lead to 99–95."],
            sourceRefs: ["NBA play-by-play"]
        },
        {
            id: "anunoby-final-stop",
            replayAtMs: 177_832,
            clock: clock(4, "4th", "11.1"),
            kind: "run",
            facts: [
                "OG Anunoby blocked De'Aaron Fox at the rim with New York down 106–105, creating the final winning possession."
            ],
            sourceRefs: ["NBA play-by-play 18a34c885b0b actions 714–715"]
        },
        {
            id: "winning-tip",
            replayAtMs: 179_000,
            clock: clock(4, "4th", "2.1"),
            kind: "score",
            facts: ["OG Anunoby's tip put New York ahead 107–106 in the final seconds."],
            sourceRefs: ["NBA play-by-play", "NBA owned social video"]
        },
        {
            id: "brunson-one",
            replayAtMs: 160_971,
            clock: clock(4, "4th", "2:21"),
            kind: "score",
            facts: ["Jalen Brunson's pull-up three cut the deficit to 104–103."],
            sourceRefs: ["NBA play-by-play"]
        },
        {
            id: "knicks-first-lead",
            replayAtMs: 168_629,
            clock: clock(4, "4th", "1:22"),
            kind: "milestone",
            facts: ["Brunson's floater gave New York its first lead at 105–104."],
            sourceRefs: ["NBA play-by-play"]
        },
        {
            id: "spurs-retake",
            replayAtMs: 175_340,
            clock: clock(4, "4th", "30.3"),
            kind: "score",
            facts: ["Stephon Castle made two free throws to put San Antonio back ahead 106–105."],
            sourceRefs: ["NBA play-by-play"]
        },
        {
            id: "finals-final",
            replayAtMs: 180_000,
            clock: clock(4, "Final", "0:00"),
            kind: "final",
            facts: [
                "New York won 107–106 after trailing by 29.",
                "It was the largest comeback in NBA Finals history.",
                "OG Anunoby scored 33 on 10-of-15 shooting, blocked Fox with 11.1 seconds left and tipped in the winner.",
                "Jalen Brunson scored 36 with seven assists and supplied New York's first lead.",
                "Victor Wembanyama led San Antonio's two-way effort with 24 points, 13 rebounds and three blocks."
            ],
            sourceRefs: ["NBA box score", "NBA game recap", "X 2064914904339911156"]
        },
        {
            id: "finals-end-fourth",
            replayAtMs: 180_000,
            clock: clock(4, "End 4th", "0:00"),
            kind: "score",
            facts: ["The fourth-quarter horn confirmed New York's 107–106 win."],
            sourceRefs: ["NBA box score 2f237b43f2c7", "NBA play-by-play 18a34c885b0b"]
        }
    ],
    feedAssets: [
        {
            id: "finals-open",
            revealAtMs: 0,
            kind: "welcome",
            evidenceIds: ["finals-pregame"],
            presentation: {
                label: "Before tip",
                eyebrow: "Madison Square Garden · Coming up",
                headline: "The Garden is ready for a Finals night",
                body: "The Knicks host the Spurs in a pivotal Game 4. Brunson, Anunoby and Wembanyama are at the centre of tonight's story."
            }
        },
        {
            id: "finals-pregame-story-card",
            revealAtMs: 0,
            kind: "welcome",
            evidenceIds: ["finals-pregame-story"],
            presentation: {
                label: "Game 4 Story",
                eyebrow: "Before tip · 26 frames",
                headline: "Game 4 can tilt the Finals",
                body: "The Spurs can level the Finals. The Knicks can move within one win. The 26-frame pregame Story sets the stakes before tip.",
                accent: "#F58426",
                storyteller: {
                    type: "story",
                    storyId: "3b4a3764-9a54-ebcb-c4b0-3a21bf208372",
                    poster: "https://storyteller-assets.nba.com/assets/studio-templates/3b4a3764-9a54-ebcb-c4b0-3a21bf208372/72180b31-571d-4eff-a3c8-fc3ed1f55132/8490cf5a-4847-bb89-ff78-3a21c3e15fbc/thumbnail_small.jpeg",
                    pageCount: 26,
                    actionLabel: "Enter the pregame Story",
                    accessibleLabel: "Open the 26-frame Spurs versus Knicks pregame story"
                }
            }
        },
        {
            id: "finals-tip-live",
            revealAtMs: 4_000,
            kind: "welcome",
            evidenceIds: ["finals-tip"],
            presentation: {
                label: "Game on",
                eyebrow: "1st · 12:00",
                headline: "Game 4 is underway",
                body: "The ball is up at Madison Square Garden. Every possession carries Finals weight."
            }
        },
        {
            id: "wemby-erasure",
            revealAtMs: 21_458,
            kind: "highlight",
            evidenceIds: ["wembanyama-block"],
            presentation: {
                label: "Defensive moment",
                eyebrow: "5:01 · 1st",
                headline: "Wembanyama erases Brunson at the rim",
                body: "Wembanyama meets New York's lead guard at full extension. San Antonio's rim protection has announced itself early.",
                caption: "Length that changes the geometry of a possession",
                accent: "#C4CED4",
                storyteller: {
                    type: "clip",
                    clipId: "11aea95a-83fb-b3ab-490a-3a21c6661156",
                    accessibleLabel: "Play Victor Wembanyama's first-quarter block"
                }
            }
        },
        {
            id: "spurs-storm",
            revealAtMs: 34_000,
            kind: "insight",
            evidenceIds: ["spurs-first-quarter"],
            presentation: {
                label: "End of 1st",
                eyebrow: "End 1st · Spurs 41–22",
                headline: "San Antonio has silenced the Garden",
                body: "Forty-one points, a 19-point lead and a first quarter played entirely on the Spurs' terms.",
                image: "/media/social/x/2064881279967928531.jpg",
                imageAlt: "The Spurs celebrate a 41–22 first-quarter lead at Madison Square Garden.",
                video: "/media/social/x/2064881279967928531.mp4",
                videoPoster: "/media/social/x/2064881279967928531.jpg",
                mediaShape: "landscape",
                source: finalsSources.firstQuarterX,
                accent: "#C4CED4",
                stats: [
                    { value: "41", label: "SAS PTS" },
                    { value: "+19", label: "MARGIN" },
                    { value: "1", label: "QUARTER" }
                ],
                actionLabel: "Watch the quarter close",
                durationLabel: "0:03"
            }
        },
        {
            id: "finals-second-quarter-live",
            revealAtMs: 34_944,
            kind: "welcome",
            evidenceIds: ["finals-second-quarter-open"],
            presentation: {
                label: "2nd quarter",
                eyebrow: "11:40 · Spurs 41–22",
                headline: "New York must stop the avalanche",
                body: "San Antonio owns a 19-point lead after 12 minutes. The Knicks must slow the ball before the margin hardens.",
                accent: "#C4CED4"
            }
        },
        {
            id: "harper-joins-the-wave",
            revealAtMs: 57_281,
            kind: "insight",
            evidenceIds: ["harper-double-figures"],
            presentation: {
                label: "Depth showing",
                eyebrow: "3:47 · 2nd",
                headline: "Harper joins the double-figure wave",
                body: "His three makes him the fourth Spur with at least 10. New York is not chasing one hot hand—it is chasing an entire team.",
                accent: "#C4CED4",
                storyteller: {
                    type: "clip",
                    clipId: "a4ea669a-445f-1cca-ef59-3a21c691b6ec",
                    accessibleLabel: "Play Dylan Harper's second-quarter three"
                }
            }
        },
        {
            id: "finals-halftime",
            revealAtMs: 68_000,
            kind: "catch-up",
            evidenceIds: ["spurs-halftime"],
            presentation: {
                label: "Halftime",
                eyebrow: "Halftime · Spurs 76–49",
                headline: "A shooting clinic has cracked Game 4 open",
                body: "San Antonio hit 11 of its first 16 threes. New York has one half to rescue its night.",
                image: "/media/getty/0042500404/2280981198.jpg",
                imageAlt: "Victor Wembanyama attempts a three over Ariel Hukporti during San Antonio's record-setting first half.",
                mediaShape: "landscape",
                source: finalsSources.wembanyama,
                caption: "The first half in one glance",
                visual: nbaVisualFixtures.finalsHalftimeInsight
            }
        },
        {
            id: "finals-second-quarter-score",
            revealAtMs: 68_000,
            kind: "insight",
            evidenceIds: ["finals-end-second"],
            presentation: {
                label: "End of 2nd",
                eyebrow: "Spurs 76 · Knicks 49",
                headline: "San Antonio scorches the first half",
                body: "Thirty-five more points turn a breathtaking opening into a 27-point halftime lead. New York has been outshot, outpaced and pushed to the edge.",
                accent: "#C4CED4",
                stats: [
                    { value: "35–27", label: "2ND QUARTER" },
                    { value: "11 / 16", label: "SAS 3PT" },
                    { value: "+27", label: "HALFTIME" }
                ]
            }
        },
        {
            id: "finals-halftime-story-card",
            revealAtMs: 68_000,
            kind: "catch-up",
            evidenceIds: ["finals-halftime-story"],
            presentation: {
                label: "Halftime Story",
                eyebrow: "Spurs 76 · Knicks 49 · 9 frames",
                headline: "See how San Antonio broke the half open",
                body: "San Antonio's historic shooting, depth and 27-point lead are collected in one vertical Story before the comeback question begins.",
                accent: "#C4CED4",
                storyteller: {
                    type: "story",
                    storyId: "4711a96a-e7d0-2150-3f8f-3a21c687bf34",
                    poster: "https://storyteller-assets.nba.com/assets/studio-templates/4711a96a-e7d0-2150-3f8f-3a21c687bf34/a5d4616f-961c-4c82-8061-eb4010e171d4/000095fa-0164-48d9-8a89-3a21c6a5ae4e/thumbnail_small.jpeg",
                    pageCount: 9,
                    actionLabel: "Open the halftime Story",
                    accessibleLabel: "Open the nine-frame Spurs versus Knicks halftime story"
                }
            }
        },
        {
            id: "twenty-nine-down",
            revealAtMs: 82_000,
            kind: "alert",
            evidenceIds: ["largest-deficit"],
            presentation: {
                label: "Game alert",
                eyebrow: "9:40 · 3rd",
                headline: "Twenty-nine down. History says this is over.",
                body: "The Spurs are back at their game-high 29-point lead, first reached late in the second quarter. Erasing it would set an NBA Finals record.",
                accent: "#F58426"
            }
        },
        {
            id: "knicks-response",
            revealAtMs: 112_000,
            kind: "moment",
            evidenceIds: ["knicks-still-alive"],
            presentation: {
                label: "End of 3rd",
                eyebrow: "End 3rd · Spurs 90–75",
                headline: "The Garden believes again",
                body: "New York has taken 14 points out of the lead. One quarter remains, and the impossible no longer feels impossible.",
                caption: "A comeback begins one possession at a time",
                accent: "#F58426"
            }
        },
        {
            id: "finals-fourth-quarter-live",
            revealAtMs: 113_176,
            kind: "welcome",
            evidenceIds: ["finals-fourth-quarter-open"],
            presentation: {
                label: "4th quarter",
                eyebrow: "11:40 · Spurs 90–75",
                headline: "Fifteen points, one quarter, a Garden waking up",
                body: "The scoreboard still belongs to San Antonio. The feeling in the room no longer does. New York has twelve minutes to turn belief into history.",
                accent: "#F58426"
            }
        },
        {
            id: "finals-comeback-lineup",
            revealAtMs: 112_000,
            kind: "insight",
            evidenceIds: ["finals-comeback-five"],
            presentation: {
                label: "Lineup shift",
                eyebrow: "End 3rd · Seven-minute stint",
                headline: "This five changed the temperature",
                body: "New York's comeback group scored 22 points on 8-of-11 shooting, moved the ball for six assists and finished the stint plus-15.",
                accent: "#F58426",
                visual: nbaVisualFixtures.finalsComebackFive
            }
        },
        {
            id: "finals-robinson-impact",
            revealAtMs: 112_000,
            kind: "insight",
            evidenceIds: ["robinson-screen-assists"],
            presentation: {
                label: "Invisible work",
                eyebrow: "Through 3rd · Off-ball impact",
                headline: "Robinson's screens put eight points on the board",
                body: "Three actions without a shot or assist in the box score helped create the space New York needed.",
                accent: "#F58426",
                visual: nbaVisualFixtures.finalsRobinsonImpact
            }
        },
        {
            id: "third-quarter-run",
            revealAtMs: 94_880,
            kind: "moment",
            evidenceIds: ["third-quarter-surge"],
            presentation: {
                label: "Run building",
                eyebrow: "5:31 · 3rd",
                headline: "Twenty-nine has become sixteen",
                body: "Anunoby, Brunson and Hart have turned the third quarter. The scoreboard is moving—and so is the building.",
                image: "/media/finals/anunoby-dunk.jpg",
                imageAlt: "OG Anunoby attacks the basket as New York begins its comeback.",
                accent: "#F58426"
            }
        },
        {
            id: "single-digit-game",
            revealAtMs: 133_483,
            kind: "alert",
            evidenceIds: ["single-digits"],
            presentation: {
                label: "Game alert",
                eyebrow: "6:35 · 4th",
                headline: "Single digits. The comeback is real.",
                body: "Anunoby hits from three, steals Harper's pass and feeds Towns at the rim. Shot-making, defense and creation turn 14 points into nine in 28 seconds.",
                image: "/media/social/x/2064909169254391982.jpg",
                imageAlt: "Karl-Anthony Towns attacks during the Knicks' fourth-quarter comeback.",
                video: "/media/social/x/2064909169254391982.mp4",
                videoPoster: "/media/social/x/2064909169254391982.jpg",
                mediaShape: "square",
                source: finalsSources.townsX,
                accent: "#F58426",
                actionLabel: "Watch Towns power the comeback",
                durationLabel: "0:10"
            }
        },
        {
            id: "hart-steals-a-possession",
            revealAtMs: 163_697,
            kind: "moment",
            evidenceIds: ["hart-defensive-hinge"],
            presentation: {
                label: "Defensive hinge",
                eyebrow: "2:00 · 4th · Spurs 104–103",
                headline: "Hart steals a possession New York cannot spare",
                body: "Fox tries to create breathing room; Hart takes the ball instead. New York has stolen another chance with the margin still at one.",
                accent: "#F58426"
            }
        },
        {
            id: "anunoby-four-point-game",
            revealAtMs: 146_000,
            kind: "alert",
            evidenceIds: ["anunoby-four"],
            presentation: {
                label: "Garden rising",
                eyebrow: "4:34 · 4th",
                headline: "Anunoby from three. Four-point game.",
                body: "The shot falls, the noise spikes and a Finals record is suddenly within reach.",
                accent: "#F58426",
                storyteller: {
                    type: "clip",
                    clipId: "55d270bd-a139-9575-3ca2-3a21c6dea1f1",
                    accessibleLabel: "Play OG Anunoby's fourth-quarter three"
                }
            }
        },
        {
            id: "anunoby-tip",
            revealAtMs: 179_000,
            kind: "highlight",
            evidenceIds: ["winning-tip"],
            presentation: {
                label: "Winning moment",
                eyebrow: "Final seconds · Knicks 107–106",
                headline: "Anunoby completes the impossible",
                body: "One instinctive tip, one deafening Garden and the largest comeback the NBA Finals has ever seen.",
                storyteller: {
                    type: "clip",
                    clipId: "50a4fb9c-84da-e466-180b-3a21c6ee95cd",
                    poster: "https://storyteller-assets.nba.com/assets/clips/50a4fb9c-84da-e466-180b-3a21c6ee95cd/a9672028-8fb2-3d24-642b-3a21c6eea048/BestThumbnail.webp",
                    accessibleLabel: "Play OG Anunoby's game-winning tip"
                }
            }
        },
        {
            id: "finals-winning-court",
            revealAtMs: 179_000,
            kind: "moment",
            evidenceIds: ["spurs-retake", "anunoby-final-stop", "winning-tip"],
            presentation: {
                label: "Possession mapped",
                eyebrow: "Final 40 seconds · Knicks 107–106",
                headline: "Anunoby wins the game at both rims",
                body: "Brunson misses, Castle puts San Antonio back in front, then Brunson misses again. Anunoby blocks Fox with 11.1 seconds left; after Brunson's third miss, Anunoby supplies the winning touch.",
                accent: "#F58426",
                visual: nbaVisualFixtures.finalsWinningSequence
            }
        },
        {
            id: "brunson-one-point-game",
            revealAtMs: 160_971,
            kind: "alert",
            evidenceIds: ["brunson-one"],
            presentation: {
                label: "Clutch shot",
                eyebrow: "2:21 · 4th",
                headline: "Brunson pulls up. One-point game.",
                body: "Thirty-four points for New York's captain, and the Garden is waiting for one more stop.",
                accent: "#F58426",
                stats: [
                    { value: "34", label: "BRUNSON" },
                    { value: "1", label: "POINT" },
                    { value: "2:21", label: "LEFT" }
                ],
                storyteller: {
                    type: "clip",
                    clipId: "1e799687-a2b8-3138-02d1-3a21c6e279cd",
                    accessibleLabel: "Play Jalen Brunson's three to cut the deficit to one"
                }
            }
        },
        {
            id: "knicks-take-lead",
            revealAtMs: 168_629,
            kind: "moment",
            evidenceIds: ["knicks-first-lead"],
            presentation: {
                label: "Lead change",
                eyebrow: "1:22 · 4th",
                headline: "Brunson puts New York in front",
                body: "Hart's steal denied San Antonio, Wembanyama missed twice at the line and Towns secured the rebound. Brunson takes the next chance and erases all 29 points.",
                image: "/media/finals/anunoby-go-ahead-celebration.jpg",
                imageAlt: "New York celebrates during its dramatic fourth-quarter comeback.",
                accent: "#F58426"
            }
        },
        {
            id: "spurs-last-word",
            revealAtMs: 175_340,
            kind: "alert",
            evidenceIds: ["spurs-retake"],
            presentation: {
                label: "Lead change",
                eyebrow: "30.3 · 4th",
                headline: "San Antonio takes it back",
                body: "Castle makes both free throws. Spurs 106, Knicks 105. New York has one final possession.",
                accent: "#C4CED4"
            }
        },
        {
            id: "finals-final-social",
            revealAtMs: 180_000,
            kind: "recap",
            evidenceIds: ["finals-final"],
            presentation: {
                label: "From the Knicks",
                eyebrow: "Final · Knicks 107–106",
                headline: "New York makes history official",
                body: "A 29-point deficit becomes a 107–106 win and a 3–1 Finals lead.",
                image: "/media/social/x/2064914904339911156.jpg",
                imageAlt: "The Knicks' official social graphic celebrating a historic 107–106 comeback win.",
                mediaShape: "portrait",
                source: finalsSources.finalX,
                accent: "#F58426",
                stats: [
                    { value: "107–106", label: "FINAL" },
                    { value: "29", label: "COMEBACK" },
                    { value: "3–1", label: "SERIES" }
                ]
            }
        },
        {
            id: "finals-comeback-flow",
            revealAtMs: 180_000,
            kind: "recap",
            evidenceIds: ["finals-final"],
            presentation: {
                label: "Game flow",
                eyebrow: "Final · Official scoring timeline",
                headline: "Every point of the comeback",
                body: "New York's margin fell to minus-29, crossed zero for the first time with 1:22 left and finished one point above it.",
                accent: "#F58426",
                visual: nbaVisualFixtures.finalsComebackFlow
            }
        },
        {
            id: "finals-photo-story",
            revealAtMs: 180_000,
            kind: "gallery",
            evidenceIds: ["finals-final"],
            presentation: {
                label: "Photo story",
                eyebrow: "Final · 3 frames",
                headline: "The comeback in three frames",
                body: "The winning touch, the arena-wide release and the Garden crowd that carried the night beyond the final buzzer.",
                accent: "#F58426",
                gallery: [
                    {
                        image: "/media/getty/0042500404/2280353181.jpg",
                        alt: "OG Anunoby tips in the game winner with 2.2 seconds remaining.",
                        source: finalsSources.winner
                    },
                    {
                        image: "/media/getty/0042500404/2280994424.jpg",
                        alt: "Madison Square Garden celebrates the Knicks' 107–106 victory.",
                        source: finalsSources.arena
                    },
                    {
                        image: "/media/getty/0042500404/2280345752.jpg",
                        alt: "Fans gather outside Madison Square Garden on the night of Game 4.",
                        source: finalsSources.exterior
                    }
                ]
            }
        },
        {
            id: "finals-recap",
            revealAtMs: 180_000,
            kind: "recap",
            evidenceIds: ["finals-final"],
            presentation: {
                label: "Final",
                eyebrow: "Knicks 107 · Spurs 106",
                headline: "Brunson erased it. Anunoby won both final possessions.",
                body: "Brunson's 36 points and seven assists drove New York from 29 down to its first lead. Anunoby paired 33 points with the 11.1-second block and winning tip; Wembanyama's 24 points, 13 rebounds and three blocks led San Antonio's resistance.",
                storyteller: {
                    type: "story",
                    storyId: "36765612-8416-f449-5d9a-3a21c7246e42",
                    poster: "https://storyteller-assets.nba.com/assets/studio-templates/36765612-8416-f449-5d9a-3a21c7246e42/07390f04-c496-4e3e-ad40-0b35e8361131/f85b6553-f367-07ee-7c30-3a21c7707e9c/thumbnail_small.jpeg",
                    pageCount: 7,
                    actionLabel: "See every winning angle",
                    accessibleLabel: "Open all seven angles of OG Anunoby's game winner"
                },
                stats: [
                    { value: "29", label: "COMEBACK" },
                    { value: "36 / 7", label: "BRUNSON" },
                    { value: "33 PTS", label: "ANUNOBY · 2 FINAL PLAYS" }
                ]
            }
        },
        {
            id: "finals-fourth-quarter-score",
            revealAtMs: 180_000,
            kind: "insight",
            evidenceIds: ["finals-end-fourth"],
            presentation: {
                label: "End of 4th",
                eyebrow: "Knicks 107 · Spurs 106",
                headline: "Forty-one points changed the meaning of the night",
                body: "New York entered the fourth trailing by 15 and left it ahead by one. The final quarter was not a rally; it was a complete rewriting of Game 4.",
                accent: "#F58426",
                stats: [
                    { value: "32–16", label: "4TH QUARTER" },
                    { value: "+1", label: "FINAL" },
                    { value: "29", label: "ERASED" }
                ]
            }
        }
    ]
};
